// extracted by mini-css-extract-plugin
export default {"root":"Chat_root__M3K11"};